import * as _actions from './actions';
import _reducer from './reducer';
import _ProgressTest from './model';
import * as _accessors from './accessors';

_ProgressTest.actions = _actions;
_ProgressTest.accessors = _accessors;

export const actions = _actions;
export const accessors = _accessors;
export const reducer = _reducer;
export const ProgressTest = _ProgressTest;



// WEBPACK FOOTER //
// ./data/ProgressTests/index.js